import React from 'react';
import PhonicsAtoZ from './PhonicsAtoZ';
import letterData from './phonics/phonics_data_ii';

/**
 * Phonics Letter Ii 页面
 * 复用 PhonicsAtoZ 通用组件
 */
function PhonicsIi() {
  return <PhonicsAtoZ letterData={letterData} />;
}

export default PhonicsIi;
